import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Promo from './Promo';
import Copyright from './Copyright';
import Logo from '../Header/Logo';
import DefaultLogo from '../Header/Logo/DefaultLogo';
import { headerSettingsShape } from '../Header/headerWidgetHelper';
import { getImageUrl } from '../../helpers/imageUrlHelpers';

import './Footer.module.scss';

const defailtLogoImage = <DefaultLogo light />;

class Footer extends React.PureComponent {
  render() {
    const {
      isMobile,
      isWideScreen,
      showPromo,
      showCopyright,
      copyright,
      imageLink,
      mobileImageUrl,
      imageUrl,
      imageScale,
      designSettings,
      designSettings: {
        footerBackgroundColor: backgroundColor,
      },
    } = this.props;

    const styleName = classNames('footer', {
      'mobile': isMobile,
      'wide-screen': isWideScreen,
    });
    const imageSrc = getImageUrl(imageUrl, mobileImageUrl, isMobile);

    return (
      <div styleName={styleName} style={{ backgroundColor }}>
        <div styleName="logo-with-copyright">
          <div key="logo" styleName="logo">
            <Logo
              isMobile={isMobile}
              imageLink={imageLink}
              imageUrl={imageSrc}
              imageScale={imageScale}
              align="left"
              defaultImage={defailtLogoImage}
            />
          </div>
          { showCopyright &&
          <div key="copyright" styleName="copyright">
            <Copyright designSettings={designSettings}>{copyright}</Copyright>
          </div>
          }
        </div>
        { showPromo && <Promo designSettings={designSettings} />}
      </div>
    );
  }
}

Footer.propTypes = {
  isMobile: PropTypes.bool,
  designSettings: PropTypes.shape({
    footerBackgroundColor: PropTypes.string,
    footerCopyrightTextColor: PropTypes.string,
  }),
  ...headerSettingsShape,
};

export default Footer;